<script>
import Component from '~/sites/soh/pages/search/index'
export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/hledat',
      de: '/suche',
      en: '/search',
      sk: '/hladat',
    },
  },
}
</script>
